module.exports = __webpack_public_path__ + "img/1493718330.12849c60.jpg";